import styled from "styled-components";

export const ErrorBlockWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 48px;
  font-size: 24px;
  color: ${(props) => props.theme.error};
`;

export const ErrorMessagekWrapper = styled.div`
  width: 100vw;
h1{
  margin: 0;
  font-size: 10vw;
}
span{
  font-size: ${(props) => props.theme.margin30};
  font-weight: 300;
}
 div{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: ${(props) => props.theme.padding15};
 }
 button{
  padding: ${(props) => props.theme.padding10} ${(props) => props.theme.padding40};
  font-size: ${(props) => props.theme.padding15};
 }
 font-size: ${(props) => props.theme.padding20};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 93vh;
`;
